import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton as RadioButtonUI } from '../../../RadioButton';

export const RadioButtonField = (props) => {
  const {
    value,
    children,
    ...contentProps
  } = props;

  return (
    <RadioButtonUI
      value={value.toString()}
      {...contentProps}
    >
      {children}
    </RadioButtonUI>
  );
};

RadioButtonField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
